import React from 'react';
import { FooterTypes } from './footerTypes';
import {
  ReachUsFacilityAddress,
  ReachUsEmailAddress,
  ReachUsPhoneNumber,
} from './helpers/FooterReachUsHelper';

export const FooterReachUs = (
  reachUsDetails: FooterTypes.TContactDetailsFooter
) => {
  return (
    <>
      <ul className="reachUsList">
        <ReachUsFacilityAddress {...reachUsDetails} />
        <ReachUsEmailAddress {...reachUsDetails} />
        <ReachUsPhoneNumber {...reachUsDetails} />
      </ul>
    </>
  );
};
